import React from "react";
import { withTranslation } from "react-i18next";
import { H2 } from "src/atoms/typography";
import { Lottie } from "src/components/Lottie";
import { SceneLayout } from "src/components/SceneLayout";
import NavigationButtons from "src/components/NavigationButtons";
import NoStationFound from "./NoStationFound";
import { Button } from "@chakra-ui/react";

class LookingForStations extends React.Component {
  state = { showNotFoundButton: false, renderNoStationFound: false };

  componentDidMount = () => {
    this.timeoutId = setTimeout(() => {
      this.setState({ showNotFoundButton: true });
    }, 3000);
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeoutId);
  };

  handleRenderNoStationFound() {
    this.setState({ renderNoStationFound: true });
  }

  render() {
    const { showNotFoundButton, renderNoStationFound } = this.state;
    const { t, isConnecting } = this.props;

    return (
      <>
        {!isConnecting && (
          <NavigationButtons
            mode="fullScreen"
            onBack={
              renderNoStationFound
                ? () => {
                    this.setState({ renderNoStationFound: false });
                  }
                : ({ navigate }) => navigate("/dashboard")
            }
          />
        )}
        {renderNoStationFound ? (
          <NoStationFound />
        ) : (
          <SceneLayout
            center={
              <>
                <Lottie
                  animationName="looking-for-bs.json"
                  delay={500}
                  width={["176px", "234px", "264px"]}
                  height={["128px", "170px", "192px"]}
                />
                <H2
                  color="highEmphasis"
                  maxWidth="320px"
                  fontSize={["2rem", "2.8rem", "3.2rem"]}
                  textAlign="center"
                  mt="24px"
                  mb="32px"
                >
                  {t("parentStation.lookingForStations.heading")}
                </H2>
              </>
            }
            bottom={
              <>
                {showNotFoundButton && (
                  <Button
                    variant="outlinedPrimary"
                    mb="24px"
                    onClick={() => this.handleRenderNoStationFound()}
                  >
                    {t("parentStation.lookingForStations.notFoundButton")}
                  </Button>
                )}
              </>
            }
          />
        )}
      </>
    );
  }
}

export default withTranslation()(LookingForStations);
